export const DEPARTURE_FLIGHT_ICON = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/form-icons/depature_flight.svg";
export const LocationPinIcon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/form-icons/location-pin.svg";
export const ARROW_RIGHT_WHITE_ICON = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/arrow_right_white_icon.svg";

// Meet & Assist places and the list of locations that offer the service live in
// utils/meetAssist.js, alongside the per-location rules that go with them.
// Re-exported here so the existing imports in this folder keep working.
export {
    TOKYO_STATION_PLACE_ID,
    SHINJUKU_STATION_PLACE_ID,
    SHINAGAWA_STATION_PLACE_ID,
    HANEDA_AIRPORT_PLACE_ID,
    NARITA_AIRPORT_PLACE_ID,
    MEET_SERVICE_PLACE_IDS,
    TERMINAL_SELECTION_PLACE_IDS,
} from "../../../utils/meetAssist";

export { NIGHT_HOURS, NIGHT_SURCHARGE_RATE } from "../../../utils/meetAssist";

export const PASSENGER_TITLE_OPTIONS = [
    { label: "Mr.", value: "Mr." },
    { label: "Ms.", value: "Ms." },
    { label: "Mrs.", value: "Mrs." },
];

export const PASSENGER_TITLE_WITH_EMPTY_OPTIONS = [
    { label: "Mr.", value: "Mr." },
    { label: "Ms.", value: "Ms." },
    { label: "Mrs.", value: "Mrs." },
    { label: "-", value: "-" },
];

export const TERMINAL_OPTIONS = [
    { label: "Terminal 1", value: "terminal-1" },
    { label: "Terminal 2", value: "terminal-2" },
    { label: "Terminal 3", value: "terminal-3" },
];

export const TRAVEL_AREA_OPTIONS = [
    { label: "ByTheHour.TravelArea.WithinCity", value: "withinCity" },
    { label: "ByTheHour.TravelArea.NeighboringPerfecture", value: "neighboringPerfecture" },
    { label: "ByTheHour.TravelArea.Undecided", value: "undecided" },
];

export const DATE_TIME_FORMAT = {
    "en": "MMM. Do, YYYY (ddd) HH:mm",
    "jp": "YYYY年M月D日(dd) HH:mm"
}

// How the long distance fee is decided in the "Basic Information" section.
// AUTOMATIC = calculated by the server from the route distance.
// MANUAL    = typed in by the admin (JPY, charged per vehicle).
export const LONG_DISTANCE_FEE_TYPE = {
    AUTOMATIC: "automatic",
    MANUAL: "manual",
};
